export default function StatsApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getEmailStats() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/processingStats/Emails`));
        });
    }

    function getCurrentIssues() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/processingStats/CurrentIssues`));
        });
    }

    function getGrandTotals(){
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/processingStats/GrandTotals`));
        });
    }

    return {
        getEmailStats,
        getCurrentIssues,
        getGrandTotals 
    }

}